// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (email-edit e email-list)

import { Injectable } from '@angular/core';
import { Email } from './email.model';
import { Subject } from 'rxjs';

@Injectable()
export class EmailService {
  private email: Email[] = [];
  emailChanged = new Subject<Email[]>();
  emailEditMode = new Subject<number>();
  emailcountChanged = new Subject<string>();
  private emailcount: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getEmail() {
    return this.email;
  }
  getEmailcount() {
    return this.emailcount;
  }
  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setEmail(email: Email[]) {
    if (email !== null) {
      this.email = email;
      if (this.email) this.emailChanged.next(this.email.slice()); else this.emailChanged.next([])

    }
  }
  setEmailcount(emailcount: string) {
    if (emailcount !== null) {
      this.emailcount = emailcount;
      this.emailcountChanged.next(this.emailcount.slice());
    }
  } 
}
